module.exports = function() {
  return new Worker(__webpack_public_path__ + "3b9a3ffcffccad0e8fb7.worker.js");
};